import { useQuery as useReactQuery, UseQueryResult } from 'react-query';
import { axiosInstance } from '../api/api';

export type Query = {
  sort?: string;
  size?: number;
  page?: number;
  search?: string;
};

const staleTime = 1000 * 900; // 15 minutes

type Options = {
  retry?: boolean;
  enabled?: boolean;
  staleTime?: number;
  keepPreviousData?: boolean;
};

type Config = {
  path: string;
  query?: Query;
  options?: Options;
};

export function useQuery<T>(config: Config): UseQueryResult<T> {
  return useReactQuery<T, Error>([config.path, config.query], async (): Promise<T> => {
    const result = await axiosInstance().get(config.path, { params: config.query });
    return result.data as T;
  }, {
    retry: config.options?.retry ?? false,
    enabled: config.options?.enabled ?? true,
    keepPreviousData: config.options?.keepPreviousData ?? false,
    staleTime: config.options?.keepPreviousData ? staleTime : undefined
  });
}
